// English (default) dictionary — master content source.
const en = {
  meta: {
    langName: "English",
    home_title: "Plastic Surgery in Vietnam | Independent Patient Guidance",
    home_description:
      "Explore plastic surgery options in Vietnam with independent guidance on procedures, surgeon selection, safety, costs, travel and recovery for international patients.",
  },
  announcement: {
    text: "Independent international patient support — not a clinic or hospital.",
    link: "How our case-review process works",
  },
  nav: {
    procedures: "Procedures",
    choosing: "Choosing a Surgeon",
    safety: "Safety",
    costs: "Costs",
    revision: "Revision Surgery",
    results: "Results",
    journey: "Patient Journey",
    guides: "Guides",
    about: "About",
    contact: "Contact",
    editorial: "Editorial Policy",
  },
  cta: {
    caseReview: "Request a Case Review",
    compare: "Compare Your Options",
    explore: "Explore Procedures",
    talk: "Talk to Our Team",
    guidance: "Get Treatment Guidance",
    sendPhotos: "Send Photos for Review",
    exploreOptions: "Explore Options",
    submitReview: "Submit for Private Review",
    revisionReview: "Request a Revision Case Review",
    whatsapp: "WhatsApp",
    menu: "Menu",
    close: "Close",
  },
  hero: {
    line1: "Considering",
    line2: "Plastic Surgery",
    line3: "in Vietnam?",
    subheading:
      "Get independent support, compare suitable options, and understand your treatment journey before you travel.",
    paragraph:
      "Plastic Surgery Vietnam offers independent patient guidance on plastic surgery options in Vietnam — helping international patients understand safety, costs and recovery, and organise case reviews, consultations and practical support before, during and after treatment.",
    trust: [
      "Private and confidential",
      "No obligation to proceed",
      "International patient support",
    ],
    scroll: "Scroll to explore",
  },
  marquee: [
    "Understand your options",
    "Independent guidance",
    "Licensed medical professionals",
    "Realistic expectations",
    "Private & confidential",
    "International patient support",
  ],
  form: {
    heading: "Request a Private Case Review",
    intro:
      "Tell us what you are considering. Our team will review your enquiry and explain the appropriate next steps.",
    fullName: "Full name",
    country: "Country",
    email: "Email",
    phone: "Phone or WhatsApp number",
    preferredContact: "Preferred contact method",
    procedureCategory: "Procedure category",
    procedureType: "Is this your first procedure or revision surgery?",
    preferredMonth: "Preferred month of travel",
    message: "Short message",
    photoUpload: "Optional secure photo upload",
    photoHint: "JPG, PNG or WEBP — up to 12 MB each. Photos are stored securely.",
    consent:
      "I consent to Plastic Surgery Vietnam contacting me about my enquiry and I have read the privacy and medical disclaimer.",
    contactOptions: { email: "Email", phone: "Phone", whatsapp: "WhatsApp" },
    categoryOptions: {
      unsure: "I am not sure",
      face: "Face",
      nose: "Nose",
      breast: "Breast",
      body: "Body",
      revision: "Revision surgery",
      other: "Other",
    },
    typeOptions: {
      firstTime: "First-time procedure",
      previousNoProblem: "Previous surgery with no current problem",
      revision: "Revision or corrective surgery",
      complication: "Complication or urgent concern",
    },
    placeholders: {
      select: "Please select",
      message: "Briefly describe what you are considering...",
      month: "e.g. March 2026",
    },
    success: {
      heading: "Thank you — your enquiry has been received",
      points: [
        "Your enquiry has been received by our patient support team.",
        "Photographs do not replace an in-person examination.",
        "A final treatment recommendation comes from a licensed medical professional.",
        "We will contact you through your selected communication method.",
      ],
      again: "Submit another enquiry",
    },
    errors: {
      required: "This field is required",
      email: "Please enter a valid email address",
      consent: "Please provide your consent to continue",
      submit: "Something went wrong. Please try again.",
    },
    disclaimer:
      "Photographs help with an initial review only. A final treatment recommendation always comes from a licensed medical professional after an in-person examination.",
  },
  footer: {
    description:
      "An independent international patient information and coordination platform for people considering plastic, cosmetic, reconstructive or revision surgery in Vietnam.",
    procedures: "Procedures",
    guides: "Patient Guides",
    contact: "Contact",
    languages: "Language",
    legal: "Legal",
    rights: "All rights reserved.",
  },
  common: {
    learnMore: "Learn more",
    readGuide: "Read guide",
    backHome: "Back to home",
    breadcrumbHome: "Home",
    translationNotice:
      "The full French and German content is currently being prepared by our team. Interface and key information are available in your language; some detailed articles are shown in English while professional translations are finalised.",
  },
};

export default en;
